/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import React from "react";
import { ExtendedTooltip, SVGIcon } from "@nordcloud/gnui";
import { duplicateIconConfig } from "./constants";

type Props = {
  resourceId: string;
  onIconClick?: (resourceId: string) => void;
};

export function DuplicateResourceIcon({ resourceId, onIconClick }: Props) {
  const handleClick = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.stopPropagation();
    onIconClick?.(resourceId);
  };

  return (
    <ExtendedTooltip
      caption={duplicateIconConfig.tooltip}
      placement={duplicateIconConfig.tooltipPlacement}
    >
      <SVGIcon
        name={duplicateIconConfig.icon}
        color={duplicateIconConfig.color}
        css={{ cursor: onIconClick ? "pointer" : "default" }}
        onClick={onIconClick ? handleClick : undefined}
      />
    </ExtendedTooltip>
  );
}
